import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Grid, Box } from '@mui/material'
import { MuiTextField, MuiButton, Loader } from '../../../../../components'
import { useGlobalStore } from '../../../../../store'
import questionManagement from '../../../../../services/questionManagement.service'
import { validateLocalPassword, consoleLog } from '../../../../../util'
import { OuterWrapper, Error, Message } from './style'

const Add = ({ onChange }) => {
  const { company } = useGlobalStore()
  const initialFormObj = {
    sourceInput: '',
    passCodeInput: ''
  }

  const form = useRef()
  const [formData, setFormData] = useState(initialFormObj)
  const [formError, setFormError] = useState('')
  const [formSuccess, setFormSuccess] = useState('')
  const [loader, setLoader] = useState(false)

  const onChangeHandler = (key, value) => {
    const obj = {
      ...formData,
      [key]: value || null
    }
    setFormData(obj)
  }

  const submitPayload = async (e) => {
    e.preventDefault()
    const obj = {
      sourceInput: formData?.sourceInput?.trim() || '',
      passCodeInput: formData?.passCodeInput?.trim() || ''
    }

    // if (obj.sourceInput === '' || !['testfreak', 'rspoweraccess'].includes(obj.passCodeInput)) {
    if (obj.sourceInput === '' || !validateLocalPassword(obj.passCodeInput, 'questionManagement')) {
      setFormError('Please enter a valid passcode to execute the operation.')
      return false
    }

    const payload = { newOrganizationId: company?.OrganizationId, masterOrganizationWebName: obj.sourceInput }
    setLoader(true)

    // keywordManagement.setOrganizationAggregationKeywordMapApi(payload)
    questionManagement.setOrganizationAggregationCopyQuestionsApi(payload)
      .then(resp => {
        if (resp === 'error') {
          setFormError('Invalid Details!')
          return false
        }
        setFormSuccess('Generated Successfully !!')
        setFormData(initialFormObj)
        setTimeout(() => {
          resetForm()
        }, 2000)
      })
      .catch(error => {
        setFormError('Kindly retry')
        consoleLog('ERROR : ', error)
      })
      .finally(() => {
        setLoader(false)
      })
  }

  const resetForm = () => {
    setFormError('')
    setFormSuccess('')
  }

  return (
    <OuterWrapper>
      <form ref={form} onSubmit={submitPayload}>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <MuiTextField
              name='source'
              placeholder='Enter Source'
              onChange={(e) => onChangeHandler('sourceInput', e.target.value)}
              variant='standard'
              value={formData?.sourceInput || ''}
            />
          </Grid>
          <Grid item xs={4}>
            <MuiTextField
              name='passCode'
              placeholder='Enter Pass Code'
              onChange={(e) => onChangeHandler('passCodeInput', e.target.value)}
              variant='standard'
              value={formData?.passCodeInput || ''}
              type='password'
            />
          </Grid>
          <Grid item xs={4} style={{ justifyContent: 'space-between', display: 'flex' }}>
              <MuiButton
                onClick={submitPayload}
                type='submit'
                color='primary'
                variant='contained'
                style={{ width: '120px', marginRight: '10px' }}
              >
                Generate
              </MuiButton>
          </Grid>
          <Grid item xs={4} style={{ justifyContent: 'space-between', display: 'flex' }}>
            <Box>
              {formError && <Error>{formError}</Error>}
              {formSuccess && <Message>{formSuccess}</Message>}
            </Box>
          </Grid>
        </Grid>
        {loader && <Loader />}
      </form>
    </OuterWrapper>
  )
}

Add.propTypes = {
  onChange: PropTypes.func
}

export default Add
